import { FC, Fragment, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ExpiredToken } from '@bepro-travel/fe.shared';
// import { saveScreenshot } from '@bepro-travel/fe.utils';
import { useRecaptcha } from '@bepro-travel/fe.hooks';
import OrderBook from './OrderBook';
import RoomsSummary from './RoomsSummary';
import FlightDetails from './FlightDetails';
import SummaryCard from './SummaryDetails';
import OphirBookSkeleton from './OphirBookSkeleton';
import React from 'react';
import { OphirBookResponse } from '../../ts/interfaces/OphirBook';
import { getBookDetails } from '../../service';
import { useGetPage } from '../../hooks/useGetPage';

const OphirBookPage: FC = () => {
  const [response, setResponse] = useState<OphirBookResponse>();
  const [urlParams] = useSearchParams();
  const bookRef = useRef<HTMLDivElement>(null);
  const { handleRecapcha, isRecaptchaReady } = useRecaptcha();
  useGetPage('rutours/Book');

  useEffect(() => {
    if (!isRecaptchaReady) return;
    (async () => {
      const recaptchaToken = await handleRecapcha();

      if (!recaptchaToken) return;
      const params = Object.fromEntries(urlParams.entries());
      const newResponse = await getBookDetails({ ...(params as any), recaptchaToken });

      if (newResponse) {
        setResponse(newResponse);
      }
    })();
  }, [isRecaptchaReady]); // eslint-disable-line

  return (
    <div className="details-wrapper" ref={bookRef}>
      {!!response?.bookingModel && !response?.sessionExpired && (
        <Fragment>
          <OrderBook bookingModel={response.bookingModel} onClickBook={() => {}} />

          <div className="oph-book-sidebar">
            <RoomsSummary rooms={response.bookingModel.roomsClasses} />
            <FlightDetails flights={response.bookingModel.deals?.[0].flights} />
            <SummaryCard
              deal={response.bookingModel.deals?.[0]}
              nights={response.bookingModel.roomsClasses?.[0].nights}
            />
          </div>
        </Fragment>
      )}

      {response?.sessionExpired && <ExpiredToken  />}

      {!response && <OphirBookSkeleton />}
    </div>
  );
};

export default OphirBookPage;
